<template>
  <el-drawer v-if="drawerSwitch" :size="`${size}%`" :visible.sync="drawerSwitch" direction="rtl" :before-close="handleClose">
    <div slot="title" class="title_box">
      <div class="title_name">{{title}}</div>
      <div class="title_line"></div>
    </div>
    <div class="box" ref="box">
      <slot></slot>
      <div class="click_box" v-if="operationShow">
        <el-button size="small" style="width:100px" v-if="cancelShow" @click="close">取消</el-button>
        <el-button size="small" type="primary" style="width:100px" v-preventReClick @click="save">确认</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
export default {
  props: {
    value:{
      default: ''
    },
    title:{ //抽屉名称
        type:String,
        default:'我是标题'
    },
    size:{ //抽屉的宽度
        type:Number,
        default:50
    },
    operationShow:{ //控制操作按钮的显示与隐藏
      type:Boolean,
      default:false
    },
    cancelShow:{ //取消按钮是否显示
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
        drawerSwitch:false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (data) {
        this.drawerSwitch = data
      }
    },
    drawerSwitch: {
      immediate: true,
      handler: function (data) {
        this.$emit('input', data)
      }
    }
  },
  methods: {
    //确定按钮
    save(){
        this.drawerSwitch = false
        this.$emit('drawDialog')
    },
    close() { //取消按钮
      this.$emit('colse')
      this.drawerSwitch = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
        })
        .catch(() => { });
    }
  },
}
</script>
<style lang="scss" scoped>
.title_box {
  .title_name {
    width: 100%;
    height: 53px;
    line-height: 53px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    text-align: left;
    color: #000000;
  }
  .title_line {
    height: 1px;
    border: 1px solid #d5d5d5;
    background-color: #d5d5d5;
  }
}
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0px 20px 20px 20px;
}
.click_box {
  margin-top: 10px;
  padding-right: 25px;
  display: flex;
  justify-content: flex-end;
}
/deep/ .el-drawer__header {
    margin-bottom: 16px;

}
</style>